module.exports = __webpack_public_path__ + "static/media/lf.4ebb4a4b.jpeg";